module.exports = __webpack_public_path__ + "a922e9beca8d0c9ed412e99e017ad535.png";